import { Component, OnInit } from '@angular/core';
import { serviceURLService } from '../service/serviceURL';
import { Router } from '@angular/router';
import { TitleCasePipe } from '@angular/common';
import { environment } from './../../environments/environment';

import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';

@Component({
  selector: 'app-your-policies',
  templateUrl: './your-policies.component.html',
  styleUrls: ['./your-policies.component.css']
})
export class YourPoliciesComponent implements OnInit {

  data: any ={};
  error: any;
  insuranceDetails: Array<any> = [];
  updatedTime : any;
  backgroundAttached: Array<any> = [];
  loading: boolean = false;
  newDate: any;
  sliceCard : number = 3;
  sliceCardLength: any;
  cardVisibility: boolean;
  noDataFound: boolean = false;
  notifyPolicies: Array<any> = [];
  pamPolicies: Array<any> = [];
  alertPolicies: Array<any> = [];
  policyNumberArray: any = [];
  policyNumberdata: any = {};
  insurerLogoDetails: Array<any> = [];
  corporateEBPolicies: Array<any> = [];
  corporateNonEBPolicies: Array<any> = [];
  personalPolicies: Array<any> = [];
  personalTab: boolean = false;
  EBTab: boolean = true;
  NonEBTab: boolean = false;
  NotifyPolicyTab: boolean = false;
  private onDestroy$: Subject<void> = new Subject<void>();
  viewPolicyButton: boolean = false;
  
  constructor(private serviceURLService: serviceURLService, private router: Router, private titlecasePipe:TitleCasePipe) { }

  ngOnInit() {
    this.insurance()
    this.newDate = new Date().getTime();
    this.serviceURLService.getInsurerLogo().subscribe((successData: any) => {
      this.insurerLogoDetails = successData.data.insurerDtos;
    }, errorData => {
      this.error = errorData;
      console.log("no data");
    })
  }

  transformName(headerData){
    headerData = headerData.split(/(?=[A-Z])/).join(' ');
    return this.titlecasePipe.transform(headerData);
  }

  convertIntoTimestamp(date) {
    var chunks = date.split('-');
    var formattedDate = [chunks[1],chunks[0],chunks[2]].join("-");
    let newDate  = new Date(formattedDate);
    let timeStampDate  = newDate.getTime();
    return timeStampDate;
  }

  seeAllCards(){
    this.sliceCard = this.notifyPolicies.length;
  }

  getPolicyNumber(policyId, policyNumber, policyPlatform) {
    localStorage.setItem('policyId' , policyId);
    localStorage.setItem('policyNumber', policyNumber);
    localStorage.setItem('policyPlatform', policyPlatform);
    console.log(policyPlatform);
    // window.location.pathname = '/'
    if(policyPlatform=='pamPolicy'){
      var clickedData= {
        email: localStorage.getItem('email'), 
        name: localStorage.getItem('name'),
        mobile: localStorage.getItem('mobileNumber'),
        id:localStorage.getItem('userID'),
        type: `YourPolicies-${policyPlatform}`
        }
        this.serviceURLService.saveClicked(clickedData).subscribe((successData: any) => {
       // console.log("clicked data saved",`In Your policy using ${policyPlatform}`);
        }, errorData => {
       // console.log("clicked datanot saved",`In Your policy using ${policyPlatform}`);
        })

    }
  }

  insurance(){
    this.loading = true;
 
    var userId = localStorage.getItem("userID")
    this.backgroundAttached = []
    this.serviceURLService.getViewPolicies(userId).pipe(takeUntil(this.onDestroy$)).subscribe((successData:any) => {
      this.cardVisibility = true;

      this.pamPolicies = successData.response.pamPolicy;
      for(let policy of successData.response.pamPolicy) {
        if(policy.productType === 'EB Policy') {
          this.corporateEBPolicies.push(policy)
        } else if (policy.productType === 'Non EB Policy') {
          this.corporateNonEBPolicies.push(policy)
        } else {
          this.personalPolicies.push(policy);
        }
      }
     
      localStorage.setItem("PamPoliciesData", JSON.stringify( this.pamPolicies));
      console.log(this.corporateEBPolicies, this.corporateNonEBPolicies, this.personalPolicies)
      
      this.alertPolicies = successData.response.policyAlert
      for(let i = 0; i < (this.alertPolicies).length; i++) {
        for(let j = 0; j < (this.insurerLogoDetails).length; j++) {
          if(this.alertPolicies[i]?.insurerCode?.toLowerCase() === this.insurerLogoDetails[j]?.code?.toLowerCase()) {
            this.alertPolicies[i].insurerLogo = this.insurerLogoDetails[j].insurerLogo;
          }
        }
      }
   
      for (let i = 0; i < (this.pamPolicies).length; i++) {

        var policyData = this.pamPolicies[i];
        console.log(policyData);
        this.policyNumberArray.push(policyData.policyNumber);
      }

     // this.getInsurerLogo();
    
      if(this.notifyPolicies.length > 0 || this.pamPolicies.length > 0 || this.alertPolicies.length > 0){
        this.cardVisibility = true;
      }else{
        this.cardVisibility = false;
        this.noDataFound = true;
      }
      this.loading = false;
    }, errorData => {
      this.cardVisibility = false;
      this.loading = false;
      if(errorData.error.status === 401){
        this.router.navigate(['login']);
      }else if(errorData.error.status === 403){
        this.error = errorData.error.message;
      }
      console.log("not registered");
    })
  }


  redirectionToPam(){
    var windowReference = window.open();
    windowReference.location.href = environment.pamUrl;
  }
  // getInsurerLogo() {
  //   // this.loading = true;
  //   this.policyNumberdata =
  //   {
  //     policyNumber: this.policyNumberArray
  //   };
  //   this.serviceURLService.getInsurerLogo(this.policyNumberdata).subscribe((successData: any) => {
  //     this.insurerLogoDetails = successData.data;
  //     console.log(this.insurerLogoDetails);
  //     for(let i = 0; i < (this.policyNumberArray).length; i++) {
  //       var policyNo = this.policyNumberArray[i]
  //       var img = this.insurerLogoDetails[policyNo];
  //       console.log(img);  
  //     }
  //     // this.loading = false;
  //   }, errorData => {
  //     this.error = errorData;
  //     console.log("no data");
  //   })
  // }
}